export const getters = {
	documents: state => state.documents,
	typeDocuments: state => type => {
		if (state.documents[type]) {
			return state.documents[type]
		} else {
			return state.documents.autre[type]
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Documents/getters.js